import { forwardRef } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import styles from './radio-button.module.css';
import './radio.css';

interface RadioProps extends React.HTMLProps<HTMLInputElement> {
  twolines?: boolean;
  register?: UseFormRegisterReturn<any>;
  error?: boolean;
  errorMessage?: string;
  className?: string;
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(({ ...props }, ref) => {
  const {
    name,
    children,
    register,
    onClick,
    onChange,
    checked,
    error,
    errorMessage,
    className,
  } = props;

  return (
    <label
      className={`${styles.radio} ${checked ? styles.selected : ''} ${
        className ?? ''
      }`.trim()}
    >
      <span
        data-testid='radio-radio-mark'
        className={`${error || errorMessage ? 'error' : ''}`}
      />

      <input
        {...register}
        className={styles.input}
        onClick={onClick}
        onChange={onChange}
        name={name}
        type='radio'
        checked={checked}
        ref={ref}
      />
      <span className={styles.radioMark} />
      <span className={styles.radioLabel}>{children}</span>
    </label>
  );
});

export default Radio;
